import { render, staticRenderFns } from "./AcademyBannerLogo.vue?vue&type=template&id=a1aee464&"
import script from "./AcademyBannerLogo.vue?vue&type=script&lang=js&"
export * from "./AcademyBannerLogo.vue?vue&type=script&lang=js&"
import style0 from "./AcademyBannerLogo.vue?vue&type=style&index=0&id=a1aee464&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports